import { DEFAULT_LANG } from 'forms-utils-lib/language/LanguageConstants';
export const getDefaultLang = () => DEFAULT_LANG;